/**
 * Created by richardlovejoy on 2/12/17.
 */
import CANNON from 'cannon';

/////////////////////////////////////////////////////////////////////////
// SkeeballPhysics //////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
export default {

  // constants
  GRAVITY: -9.82,
  WALL_THICKNESS: 0.1,

  // timing
  fixedTimeStep: 1.0 / 60.0,
  maxSubSteps: 3,
  lastCallTime: 0,
  holeColliderSignals: [],
  cupColliderSignals: [],

  init(game, objects) {

    // NOTE: positions of objects passed in via config are pre-scaled into physics world coords

    // need phaser game to access data cache
    this.game = game;

    // create a 'cannon' world
    this.world = new CANNON.World();
    this.world.gravity.set(0, this.GRAVITY, 0);

    // Materials
    this.backRampMaterial = new CANNON.Material("backRampMaterial");
    this.ballMaterial = new CANNON.Material("ballMaterial");
    this.cupMaterial = new CANNON.Material("cupMaterial");
    this.wallMaterial = new CANNON.Material("wallMaterial");
    this.highWallMaterial = new CANNON.Material("highWallMaterial");

    this.ballCupMaterial = new CANNON.ContactMaterial(this.cupMaterial, this.ballMaterial, {
      friction: 0.6,
      restitution: 0.0
    });
    this.world.addContactMaterial(this.ballCupMaterial);

    /*
    this.ballBackRampMaterial = new CANNON.ContactMaterial(this.backRampMaterial, this.ballMaterial, {
      friction: 0.6,
      restitution: 0.0,
      contactEquationStiffness: 1e8,
      contactEquationRelaxation: 3,
      frictionEquationStiffness: 1e8,
      frictionEquationRegularizationTime: 3,
    });
    this.world.addContactMaterial(this.ballBackRampMaterial);
     */


    this.ballWallMaterial = new CANNON.ContactMaterial(this.wallMaterial, this.ballMaterial, {
      friction: 0.2,
      restitution: 0.3,
      contactEquationStiffness: 1e8,
      contactEquationRelaxation: 3,
      frictionEquationStiffness: 1e8,
      frictionEquationRegularizationTime: 3,
    });
    this.world.addContactMaterial(this.ballWallMaterial);

    this.ballHighWallMaterial = new CANNON.ContactMaterial(this.highWallMaterial, this.ballMaterial, {
      friction: 0.2,
      restitution: 0.0,
      contactEquationStiffness: 1e8,
      contactEquationRelaxation: 3,
      frictionEquationStiffness: 1e8,
      frictionEquationRegularizationTime: 3,
    });
    this.world.addContactMaterial(this.ballHighWallMaterial);

    // create walls
    var leftWallBody = new CANNON.Body({
      mass: 0,
      material: this.highWallMaterial,
      position: new CANNON.Vec3(objects.leftWall-this.WALL_THICKNESS/2, 0, -0.5),
      shape: new CANNON.Box(new CANNON.Vec3(this.WALL_THICKNESS/2, 2, 2))
    });
    this.world.addBody(leftWallBody);

    var rightWallBody = new CANNON.Body({
      mass: 0,
      material: this.highWallMaterial,
      position: new CANNON.Vec3(objects.rightWall+this.WALL_THICKNESS/2, 0, -0.5),
      shape: new CANNON.Box(new CANNON.Vec3(this.WALL_THICKNESS/2, 2, 2))
    });
    this.world.addBody(rightWallBody);

    var lpos = objects.leftRampWall.position;
    var leftRampWallBody = new CANNON.Body({
      mass: 0,
      material: this.wallMaterial,
      position: new CANNON.Vec3(lpos.x-this.WALL_THICKNESS/2, lpos.y, lpos.z),
      shape: new CANNON.Box(new CANNON.Vec3(this.WALL_THICKNESS/2, 0.1, 2))
    });
    this.world.addBody(leftRampWallBody);

    var rpos = objects.rightRampWall.position;
    var rightRampWallBody = new CANNON.Body({
      mass: 0,
      material: this.wallMaterial,
      position: new CANNON.Vec3(rpos.x+this.WALL_THICKNESS/2, rpos.y, rpos.z),
      shape: new CANNON.Box(new CANNON.Vec3(this.WALL_THICKNESS/2, 0.1, 2))  // these are 'half' extents
    });
    this.world.addBody(rightRampWallBody);

    var backWallBody = new CANNON.Body({
      mass: 0,
      position: objects.backWall.position,
      shape: new CANNON.Box(new CANNON.Vec3(2, 2, this.WALL_THICKNESS))
    });
    this.world.addBody(backWallBody);

    backWallBody.addEventListener('collide', e => {
      // add damping to the ball
      this.dampenBall(e.body, 0.1);
    });

    // backboard ramp
    var backrampQuaternion = new CANNON.Quaternion();
    backrampQuaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), objects.backramp.rotation.x);

    var backrampBody = new CANNON.Body({
      mass: 0,
      //material: this.backRampMaterial,
      position: objects.backramp.position,
      quaternion: backrampQuaternion,
      shape: new CANNON.Plane()
    });
    this.world.addBody(backrampBody);

    // front ramp
    var frontrampQuaternion = new CANNON.Quaternion();
    frontrampQuaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), objects.frontramp.rotation.x);

    var frontrampBody = new CANNON.Body({
      mass: 0,
      position: objects.frontramp.position,
      quaternion: frontrampQuaternion,
      shape: new CANNON.Plane()
    });
    this.world.addBody(frontrampBody);

    // ramp blocker
    var rampBlockerBodyQuaternion = new CANNON.Quaternion();
    rampBlockerBodyQuaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), 10*Math.PI/180);
    var rampBlockerBody = new CANNON.Body({
      mass: 0,
      position: objects.rampBlocker.position,
      quaternion: rampBlockerBodyQuaternion,
      shape: new CANNON.Box(new CANNON.Vec3(rpos.x, 0.75/11.915, 1.5/11.915))  // these are 'half' extents, should be passed
    });
    this.world.addBody(rampBlockerBody);


    // create cups & holes - need to apply config.scale to mesh vertices in holes
    this.cupQuaternion = new CANNON.Quaternion();
    this.cupQuaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), objects.cups.rotation.x); // why does it have to be 90-?

    objects.cups.obj.map(this.createCup, this);

    objects.holes.obj.map(this.createHole, this);

    return this;
  },

  createCup(cup) {

    // create a signal that can be dispatched when the ball hits
    var cupSignal = new Phaser.Signal();

    this.cupColliderSignals.push(cupSignal);

    // setup tri-mesh from vertices/indices
    // cup body
    var cupBody = new CANNON.Body({
      mass: 0,
      material: this.cupMaterial,
      position: cup.position,
      quaternion: this.cupQuaternion,
      shape: new CANNON.Trimesh(cup.vertices, cup.indices)
    });

    this.world.addBody(cupBody);

    cupBody.addEventListener('collide', e => {
      // add damping to the ball
      this.dampenBall(e.body, 0.02);

      // signal a cup was hit
      cupSignal.dispatch();
    });
    return cupBody;
  },

  createHole(hole) {

    // create a signal that can be dispatched when the ball hits
    var holeSignal = new Phaser.Signal();

    this.holeColliderSignals.push(holeSignal);

    // hole collider
    var holeBody = new CANNON.Body({
      mass: 0,
      position: hole.position,
      shape: new CANNON.Sphere(0.03)
    });
    holeBody.collisionResponse = 0; // make it so it doesn't affect the ball
    holeBody.addEventListener('collide', e => holeSignal.dispatch(hole.tag));
    this.world.addBody(holeBody);

    return holeBody;

  },

  startBall(initialPosition, initialVelocity, radius, weight) {

    // shape and material for the ball, low resitution
    var shape = new CANNON.Sphere(radius);

    // start cannon physics mode
    var sphereBody = new CANNON.Body({
      mass: weight, // kg
      material: this.ballMaterial,
      position: new CANNON.Vec3(initialPosition.x, initialPosition.y, initialPosition.z), // m
      shape: shape
    });
    this.world.addBody(sphereBody);

    const scalar = 0.18;//0.16;
    sphereBody.applyLocalImpulse(new CANNON.Vec3(initialVelocity.x*scalar, initialVelocity.y*scalar, initialVelocity.z*scalar), new CANNON.Vec3());

    return sphereBody;
  },

  pushBall(ballBody, power) {

    const scalar = power * 0.02;
    ballBody.applyLocalForce(new CANNON.Vec3(-ballBody.velocity.x*scalar, -ballBody.velocity.y*scalar, -ballBody.velocity.z*scalar), ballBody.position);
  },

  launchBall(ballBody, initialVelocity) {


    const scalar = 0.14;
    ballBody.applyImpulse(new CANNON.Vec3(initialVelocity.x*scalar, initialVelocity.y*scalar*1.1, -initialVelocity.z*8*scalar), ballBody.position);
    //ballBody.applyImpulse(new CANNON.Vec3(initialVelocity.x*scalar, initialVelocity.y*scalar, -initialVelocity.z*6*scalar), ballBody.position);

    // center cup
    //ballBody.applyImpulse(new CANNON.Vec3(0, 0.5, 0.67), ballBody.position);

    // center upper cup
    //ballBody.applyImpulse(new CANNON.Vec3(0, 0.5, 0.56), ballBody.position);

    // large center cup
    //ballBody.applyImpulse(new CANNON.Vec3(-0.16, 0.5, 0.56), ballBody.position);

  },

  dampenBall(ballBody, dd) {

    if (ballBody.linearDamping < 0.18)
      ballBody.linearDamping += dd;

  },

  nudgeBall(ballBody, direction) {

    ballBody.applyImpulse(new CANNON.Vec3(direction*0.01, 0, 0.02), ballBody.position);
  },

  removeBall(ballBody) {

    this.world.removeBody(ballBody);
  },

  // simulation
  step(dt) {

    this.world.step(this.fixedTimeStep, dt, this.maxSubSteps);
  },

  // vec3 creation
  vec3create(v) {
    return new CANNON.Vec3(v.x, v.y, v.z);
  }


};




// WEBPACK FOOTER //
// ./app/src/display/SkeeballPhysics.js